import { render, staticRenderFns } from "./vue-audio.vue?vue&type=template&id=1dde99af&scoped=true&"
import script from "./vue-audio.vue?vue&type=script&lang=js&"
export * from "./vue-audio.vue?vue&type=script&lang=js&"
import style0 from "./vue-audio.vue?vue&type=style&index=0&id=1dde99af&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dde99af",
  null
  
)

export default component.exports